const footerEl = document.querySelector( '.page-footer' );
const footerNvaEl = footerEl.querySelector( '.js-c-menu-footer' );
const MobileBreakpoint = 768;


/**
 * Footer
 * @description - Footer scripts
 * @function
 * @name footer
 * @return {void}
 */
const footerMenu = () => {

	if ( !footerEl ) {

		return;

	}

	if ( !footerNvaEl ) {

		return;

	}

	const footerTriggers = footerNvaEl.querySelectorAll( '.js-menu-footer-has-children .js-menu-footer-trigger' );
	footerTriggers.forEach( ( trigger ) => {

		trigger.addEventListener( 'click', ( e ) => {

			e.preventDefault();
			if ( window.innerWidth < MobileBreakpoint ) {

				trigger.classList.toggle( 'is-active' );
				const panel = trigger.nextElementSibling;
				if ( panel.style.maxHeight ) {

					panel.style.maxHeight = null;

				} else {

					panel.style.maxHeight = `${ panel.scrollHeight }px`;

				}
				trigger.nextElementSibling.classList.toggle( 'is-active' );

			}

		} );

	} );

}

export { footerMenu };